import _styled2 from "styled-components";
import _styled from "styled-components";
import React from "react";
import { Box } from "atomic-layout";
import Tippy from "@tippyjs/react";
import { colors } from "../shared/styles";
export function Popover(props) {
  return /*#__PURE__*/React.createElement(Tippy, Object.assign({
    theme: "light-border",
    delay: [0, 300],
    interactive: true,
    appendTo: document.body,
    onShow: function onShow(instance) {
      return instance.popper.addEventListener("click", function () {
        instance.hide();
      });
    },
    onHide: function onHide(instance) {
      return instance.popper.removeEventListener("click", function () {
        instance.hide();
      });
    },
    placement: "bottom"
  }, props));
}
export var Dropdown = _styled(Popover).withConfig({
  displayName: "Dropdown",
  componentId: "sc-cqgaqp-0"
})(["box-shadow:3px 2px 9px -2px rgba(0,0,0,0.5) !important;border-radius:0px !important;margin:0 !important;padding:16px 0px !important;width:300px !important;.tippy-content{padding:0 !important;}&[data-placement^=\"bottom\"] > .tippy-arrow::before{border-top-color:purple;}"]);
export function DropdownItem(props) {
  return /*#__PURE__*/React.createElement(_StyledBox, Object.assign({}, props, {
    $_css: colors.primaryBlue,
    $_css2: colors.grayLight,
    $_css3: colors.plain,
    $_css4: colors.plain
  }));
}
export var DropdownSeparator = _styled.hr.withConfig({
  displayName: "Dropdown__DropdownSeparator",
  componentId: "sc-cqgaqp-1"
})(["height:0;border:none;border-bottom:1px solid ", ";margin-top:16px;margin-bottom:16px;"], colors.grayDark);
var _StyledBox = _styled(Box).withConfig({
  displayName: "Dropdown___StyledBox",
  componentId: "sc-cqgaqp-2"
})(["line-height:30px;padding:8px 24px;color:", ";font-weight:600;text-decoration:none;&:hover{background:", ";color:", ";& > svg{color:", ";}}"], function (p) {
  return p.$_css;
}, function (p) {
  return p.$_css2;
}, function (p) {
  return p.$_css3;
}, function (p) {
  return p.$_css4;
});